import React, { FC, useEffect } from 'react';
import { Footer } from '@chr/navisphereonline-shared-components';
import { useHistory } from 'react-router-dom';
import logoModule from '@chr/autoStyle/dist/img/CHR/CHR_LogoTM_Horz_2C_RGB.png';
import './guest.scss';
import { useTranslation } from '@chr/online-shared-ui-localizations';

const Guest : FC = () => {
  const history = useHistory();
  const translate = useTranslation();

  useEffect(() => {
    document.title = 'C.H. Robinson Online';
  }, []);

  const goToHomePage = (e: any) => {
    localStorage.setItem('newSession', 'true');
    e.preventDefault();
    history.push('/');
  }

    return (
      <div id="guest">
        <div className="container main margin-top-30">
          <div>
            <img className="chr-logo" src={logoModule} alt="CHR-logo" />
          </div>
          <div className="margin-top-15">
            <h1>{translate("You have been logged out.")}</h1>
          </div>
          <div className="margin-top-15">
            <p>
              {translate("You may log back into your C.H. Robinson customer applications below.")}
            </p>
          </div>
          <div className="margin-top-20">
            <button
              onClick={goToHomePage}
              id="btnLogin"
              className="btn btn-primary"
              data-testid="btnLogin"
            >
              {translate("LOG IN")}
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
}

export default Guest;
